import certificatesFilters from "../src/assets/img/certificates-filters.png"
import certificatesPage from "../src/assets/img/certificates-page.png"

function Certificates() {
    return (
        <div className="py-5 text-start px-lg-5 px-2 ms-lg-5 text-size" >
            <h2 className="mb-3 blue-heading">Certificates Page</h2>
            <p>Certificates page contains your Certificate inventory with some additional information such as Expiry date.</p>
            <img className="w-md-75" src={certificatesPage} alt="Certificates Page"  />
            <p className="my-3">You may use your search filters and/or search bar for limiting results to a specific data. Additionally, you can download your data in CSV format by clicking “Export to CSV” button.</p>
            <img src={certificatesFilters} alt="Certificates Filter And Buttons"  />
            </div>
    )
}

export default Certificates
